/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import { Stack, Typography, Box, Container, Grid, Card, CardHeader, Button } from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import MultiSelector from '../components/multi-selector/multiSelector';
import VideoPlayer from '../components/video-player/videoPlayer';

export default function CameraVideoWall() {
  const cameraList = useSelector((state) => state.app.cameraList);
  const { adaptorType } = window;
  const [selectedCameraList, setSelectedCameraList] = useState([]);
  const [videoWallList, setVideoWallList] = useState([]);
  const [camera, setCamera] = useState();
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();

  useEffect(() => {
    window.liveStreamingCameras = selectedCameraList;
    return () => {
      window.LiveStreamingCameras = null;
    };
  }, [selectedCameraList]);

  const handleInputValue = (val) => {
    setInputValue(val);
  };

  const handleSelectedCameraListChange = (val) => {
    if (videoWallList.length > 0 && camera != null) {
      handleStop();
    } else {
      setSelectedCameraList(val);
    }
  };

  const closeCamera = (camera) => {
    const temp = selectedCameraList.filter((item) => item.sensorId !== camera.sensorId);
    setSelectedCameraList(temp);
  };

  const handlePlay = () => {
    console.log('selectedCameraList', selectedCameraList);
    if (selectedCameraList.length > 0) {
      const camList = [];
      for (let i = 0; i < selectedCameraList.length; i += 1) {
        camList.push(selectedCameraList[i].sensorId);
      }
      const camera = { name: `streams(${selectedCameraList.length})` };
      camera.ip = selectedCameraList[0].ip;
      camera.host = selectedCameraList[0].host;
      camera.sensorId = 'composite-stream';
      setCamera(camera);
      console.log('camList: ', camList);
      setVideoWallList(camList);
    } else {
      console.log('No streams selected');
    }
  };

  const handleStop = () => {
    setCamera(null);
    setVideoWallList([]);
    setSelectedCameraList([]);
  };

  const handleSelectAll = () => {
    setSelectedCameraList(cameraList);
    setVideoWallList(cameraList);
  };

  const shouldRender = videoWallList.length > 0 && camera != null;

  // Filter out selected cameras from the cameraList
  const availableCameras = cameraList.filter(
    (camera) => !selectedCameraList.some(selectedCamera => selectedCamera.sensorId === camera.sensorId)
  );

  // Function to filter authorized cameras
  const filterAuthorized = (cameraList) => cameraList
    .filter((camera) => camera.isAuthorized === true);

  return (
    <div
      style={{
        display: location.pathname === '/vst/video-wall' ? 'inline' : 'none',
      }}
    >
      <Helmet>
        <title> stream </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          {'Video wall'}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader title={'Video wall'} subheader={'Select multiple streams then click on play'} />
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="video-wall-selector-multi"
                    placeholder="Type to search"
                    label={`Select ${adaptorType === 'streamer' ? 'files' : 'cameras'}`}
                    value={selectedCameraList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedCameraListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={filterAuthorized(availableCameras)}
                  />
                </Stack>
                <Box display="flex" flexWrap="nowrap">
                  <Box m={1} display="flex" justifyContent="flex-start" alignItems="flex-start">
                    <Button variant="contained" onClick={handleSelectAll} sx={{ mr: 1 }}>
                      Select all
                    </Button>
                    <Button
                      variant="contained"
                      endIcon={shouldRender ? <StopIcon /> : <PlayArrowIcon />}
                      onClick={shouldRender ? handleStop : handlePlay}
                    >
                      {shouldRender ? 'Stop' : 'Start'}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Card>
          </Grid>
          {shouldRender && (
            <Grid item xs={12}>
              <Typography variant="h5">{`Streams (${videoWallList.length})`}</Typography>
              <VideoPlayer
                camera={camera}
                videoWallList={videoWallList}
                cameraInRow={1}
                // key={`${camera.sensorId + camera.host + camera.name}_vid_live`}
                page="video-wall"
                closeCamera={closeCamera}
                useVideoCoordinates
                onlyVideo
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
}
